@use '../@shared/mixins' as *;
@use '../@shared/global' as *;

@layer kol-component {
	.kol-meter {
		--color-optimal: var(--kol-meter-color-optimal, #2ea32e);
		--color-suboptimal: var(--kol-meter-color-suboptimal, #c8a000);
		--color-critical: var(--kol-meter-color-critical, #c00);
		--vertical-height: var(--kol-meter-vertical-height, 128);
		--horizontal-height: var(--kol-meter-horizontal-height, 12);

		&__bar {
			display: grid;
			align-items: center;
			grid-template-areas:
				'label label'
				'bar value';
			grid-template-columns: 1fr auto;

			&-label {
				grid-column-end: 2;
				grid-area: label;
			}

			&-track {
				display: flex;
				min-width: 100%;
				grid-area: bar;
			}
		}

		&__value-unit {
			grid-area: value;
		}

		&:not(&--vertical) &__value {
			display: inline-block;
			text-align: right;
		}

		&--vertical {
			min-height: 100%;

			.kol-meter__bar {
				min-height: 100%;
				align-items: end;
				justify-items: center;
				grid-template-areas:
					'label'
					'bar'
					'value';
				grid-template-columns: 1fr;
				grid-template-rows: min-content 1fr min-content;

				&-label {
					text-align: center;
				}

				&-track {
					position: relative;
					min-width: 0;
					min-height: to-rem(var(--vertical-height));
					align-items: center;
				}

				meter {
					transform: rotate(-90deg);
					transform-origin: left bottom;
					position: absolute;
					bottom: 0;
					width: to-rem(var(--vertical-height));
				}
			}
		}

		/* Base meter styling */
		meter {
			width: 100%;
			height: to-rem(var(--horizontal-height));
			/* Remove default appearance in some browsers */
			-webkit-appearance: none;
			-moz-appearance: none;
			appearance: none;
		}

		/* Chrome, Safari, Edge (WebKit/Blink) */
		meter::-webkit-meter-bar {
			background: white;
			height: to-rem(var(--horizontal-height));
			border: 1px solid black;
		}
		meter::-webkit-meter-optimum-value {
			background: var(--color-optimal);
		}
		meter::-webkit-meter-suboptimum-value {
			background: var(--color-suboptimal);
		}
		meter::-webkit-meter-even-less-good-value {
			background: var(--color-critical);
		}

		/* Firefox */
		@supports (selector(::-moz-meter-bar)) {
			meter {
				background: white;
				border: 1px solid black;
			}
		}

		meter::-moz-meter-bar {
			background: var(--color-optimal);
		}
		meter:-moz-meter-sub-optimum::-moz-meter-bar {
			background: var(--color-suboptimal);
		}
		meter:-moz-meter-sub-sub-optimum::-moz-meter-bar {
			background: var(--color-critical);
		}
	}
}
